module.exports = __webpack_public_path__ + "img/9788928100842.40fa56cb.jpg";